import React from 'react';
import PropTypes from 'prop-types';
import { offerCodeEnum } from '@@viewEnums';
import SummaryDailyBenefit from './SummaryDailyBenefit.jsx';
import SummarySelfEmployed from './SummarySelfEmployed.jsx';
import SummaryIndividualHeath from './SummaryIndividualHeath.jsx';
import { SummaryCollectiveHealth } from './SummaryCollectiveHealth.jsx';

export const OfferSummaryRenderer = ({
  offerCode,
  getMiddleText,
  getMiddleBoolean,
  grantees,
  packs,
  effectDate,
  editContract,
  viewMode,
  demography,
  formulaLevelLabel,
  project,
  tariffStructureLabel,
  pricingLevel,
  isDutyOfAdviceSkipped,
  guarantees,
  PTIADeathGuarantees,
  spousePensionGuarantees,
  educationPensionGuarantees,
  disabilityGuarantees,
  invalidityGuarantees,
  regimeObligatoire,
  customerCardOptions,
  granteesCardOptions,
  onEditBeneficiaries,
  isProjectEditable
}) => {
  switch (offerCode) {
    case offerCodeEnum.INDIVIDUAL_HEALTH:
      return (
        <SummaryIndividualHeath
          getMiddleText={getMiddleText}
          grantees={grantees}
          packs={packs}
          effectDate={effectDate}
          offerCode={offerCode}
          onEdit={editContract}
          viewMode={viewMode}
          customerCardOptions={customerCardOptions}
          granteesCardOptions={granteesCardOptions}
          onEditBeneficiaries={onEditBeneficiaries}
          isProjectEditable={isProjectEditable}
        />
      );
    case offerCodeEnum.GROUP_HEALTH:
      return (
        <SummaryCollectiveHealth
          getMiddleText={getMiddleText}
          getMiddleBoolean={getMiddleBoolean}
          demography={demography}
          formulaLevelLabel={formulaLevelLabel}
          project={project}
          tariffStructureLabel={tariffStructureLabel}
          regimeObligatoire={regimeObligatoire}
          isProjectEditable={isProjectEditable}
        />
      );
    case offerCodeEnum.INDIVIDUAL_PROTECTION_DAILY_BENEFIT:
      return isDutyOfAdviceSkipped ? (
        <SummaryDailyBenefit
          pricingLevel={pricingLevel}
          getMiddleText={getMiddleText}
          effectDate={effectDate}
          grantees={grantees}
          customerCardOptions={customerCardOptions}
          granteesCardOptions={granteesCardOptions}
          onEditBeneficiaries={onEditBeneficiaries}
          isProjectEditable={isProjectEditable}
        />
      ) : null;
    case offerCodeEnum.SELF_EMPLOYED_WORKER_PROTECTION:
      return (
        <SummarySelfEmployed
          effectDate={effectDate}
          getMiddleText={getMiddleText}
          getMiddleBoolean={getMiddleBoolean}
          guarantees={guarantees}
          PTIADeathGuarantees={PTIADeathGuarantees}
          spousePensionGuarantees={spousePensionGuarantees}
          educationPensionGuarantees={educationPensionGuarantees}
          disabilityGuarantees={disabilityGuarantees}
          invalidityGuarantees={invalidityGuarantees}
          customerCardOptions={customerCardOptions}
          granteesCardOptions={granteesCardOptions}
          onEditBeneficiaries={onEditBeneficiaries}
          grantees={grantees}
          isProjectEditable={isProjectEditable}
        />
      );
    default:
      return null;
  }
};

OfferSummaryRenderer.propTypes = {
  offerCode: PropTypes.string.isRequired,
  getMiddleText: PropTypes.func.isRequired,
  getMiddleBoolean: PropTypes.func,
  grantees: PropTypes.array,
  packs: PropTypes.array,
  effectDate: PropTypes.string,
  editContract: PropTypes.func,
  viewMode: PropTypes.string,
  demography: PropTypes.object,
  formulaLevelLabel: PropTypes.string,
  project: PropTypes.object,
  tariffStructureLabel: PropTypes.string,
  pricingLevel: PropTypes.string,
  isDutyOfAdviceSkipped: PropTypes.bool,
  guarantees: PropTypes.array,
  PTIADeathGuarantees: PropTypes.object,
  spousePensionGuarantees: PropTypes.object,
  educationPensionGuarantees: PropTypes.object,
  disabilityGuarantees: PropTypes.object,
  invalidityGuarantees: PropTypes.object,
  regimeObligatoire: PropTypes.object,
  customerCardOptions: PropTypes.array,
  granteesCardOptions: PropTypes.array,
  onEditBeneficiaries: PropTypes.func
};
